import { fetcher } from '@commenda/utils';

import type { IExternalShare } from '../file-share/types';
import { FORM_SHARES_BASE_URL } from './helpers';
import type { IUpdateFormShareRequest } from './types';

export const updateFormShare = async (
  id: string,
  body: IUpdateFormShareRequest
): Promise<{ share: IExternalShare }> => {
  const res = await fetcher(`${FORM_SHARES_BASE_URL}/${id}`, {
    method: 'POST',
    body,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to update form share link.');
  }

  return await res.json();
};
